import {Paper, Stack, Text, useMantineTheme, Group} from "@mantine/core";
import {OrderDTO} from "../../../interfaces/OrderInterfaces";
import classes from "./OrderStats.module.css";

interface OrderStatsProps {
    data?: OrderDTO[];
}

const OrderStats = ({data}: OrderStatsProps) => {
    const theme = useMantineTheme();

    if (!data) {
        return null;
    }

    const calculateStats = (marketplace: string, aliases: string[] = []) => {
        const marketplaceNames = [marketplace, ...aliases];
        const ordersForMarketplace = data.filter(o => marketplaceNames.includes(o.marketplace));
        
        const totalOrders = ordersForMarketplace.length;
        
        // IN ATTESA: PENDING, STAGING, WAITING_*
        const pendingStatuses = ['PENDING', 'STAGING', 'WAITING_ACCEPTANCE', 'WAITING_DEBIT', 'WAITING_DEBIT_PAYMENT'];
        const pending = ordersForMarketplace.filter(o => pendingStatuses.includes(o.status)).length;
        
        // IN ATTESA DI SPEDIZIONE: SHIPPING
        const shipping = ordersForMarketplace.filter(o => o.status === 'SHIPPING').length;
        
        // SPEDITI: SHIPPED, COMPLETED
        const shipped = ordersForMarketplace.filter(o => o.status === 'SHIPPED' || o.status === 'COMPLETED').length;
        
        return { totalOrders, pending, shipping, shipped };
    };

    const marketplaces: { name: string; label: string; aliases?: string[] }[] = [
        {name: 'EBAY', label: 'eBay'},
        {name: 'MEDIAWORLD', label: 'MediaWorld'},
        {name: 'LEROY_MERLIN', label: 'Leroy Merlin', aliases: ['LEROYMERLIN', 'LeroyMerlin']},
        {name: 'EPRICE', label: 'ePrice'}
    ];

    return (
        <div className={classes.statsContainer}>
            {marketplaces.map(({name, label, aliases}) => {
                const stats = calculateStats(name, aliases || []);
                
                return (
                    <Paper key={name} className={classes.statCard} withBorder>
                        <Stack gap={6}>
                            <Text size="sm" c="dimmed" fw={600} tt="uppercase">{label}</Text>
                            <Group gap="lg" justify="flex-start">
                                <div className={classes.statItem}>
                                    <Text size="xs" c="dimmed" fw={500}>TOTALI</Text>
                                    <Text size="md" fw={600} c={theme.colors.indigo?.[6] || 'indigo'}>
                                        {stats.totalOrders}
                                    </Text>
                                </div>
                                <div className={classes.statItem}>
                                    <Text size="xs" c="dimmed" fw={500}>IN ATTESA</Text>
                                    <Text size="md" fw={600} c={theme.colors.orange?.[6] || 'orange'}>
                                        {stats.pending}
                                    </Text>
                                </div>
                                <div className={classes.statItem}>
                                    <Text size="xs" c="dimmed" fw={500}>DA SPEDIRE</Text>
                                    <Text size="md" fw={600} c={theme.colors.cyan?.[6] || 'cyan'}>
                                        {stats.shipping}
                                    </Text>
                                </div>
                                <div className={classes.statItem}>
                                    <Text size="xs" c="dimmed" fw={500}>SPEDITI</Text>
                                    <Text size="md" fw={600} c={theme.colors.teal?.[6] || 'teal'}>
                                        {stats.shipped}
                                    </Text>
                                </div>
                            </Group>
                        </Stack>
                    </Paper>
                );
            })}
        </div>
    );
};

export default OrderStats;
